"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubstanceCategoryNameEnum = void 0;
var SubstanceCategoryNameEnum;
exports.SubstanceCategoryNameEnum = SubstanceCategoryNameEnum;

(function (SubstanceCategoryNameEnum) {
  SubstanceCategoryNameEnum["SubstanceType"] = "substance_type";
  SubstanceCategoryNameEnum["Characteristic"] = "characteristic";
  SubstanceCategoryNameEnum["Classification"] = "classification";
  SubstanceCategoryNameEnum["ReasonForRegulation"] = "reason_for_regulation";
})(SubstanceCategoryNameEnum || (exports.SubstanceCategoryNameEnum = SubstanceCategoryNameEnum = {}));